import React, { useContext, useEffect, useState } from "react";

import { Col, Form, Row, Space, Tooltip, Input } from "antd";
import { Button } from "Components/CommonComponents/GeneralComponents";
import "./index.css";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useDispatch } from "react-redux";
import {
  storeSelectedTag,
  storeQuestionFilter,
  StoreSubtypeEnabledInFilter,
} from "redux/action/questionAction";
import SingleSelectComponent from "Components/CommonComponents/SingleSelectComponent";
import PropTypes from "prop-types";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import useMasterContext from "Context/MasterContext";
import { QuestionType } from "utilFunctions/Constants/Constants";
const hintStatusOption = [
  { label: "--Select--", value: null },
  { label: "Verified", value: "HV" },
  { label: "Unverified", value: "HU" },
];

const QuestionFilterAntd = (props) => {
  const {
    form,
    state,
    setState,
    settags,
    setRefresh,
    setSubSubEnabled,
    inputTextLanguage,
    setInputTextLangauge,
    onCloseDrawer,
    filterValues,
    setfilterValues,
    hintSolAns,
    selectedOptionsHintAnsSol,
    fetchQuestion,
    sortBy,
    sortDir,
    limit,
  } = props;
  const dispatch = useDispatch();
  const ToastDispatch = React.useContext(ToastContextDispatch);
  const userInfo = useContext(UserInfoContext);
  const { masters } = useMasterContext();
  const [streamArray, setstreamArray] = useState([]);
  const [classArray, setclassArray] = useState([]);
  const [subjectArray, setsubjectArray] = useState([]);

  useEffect(() => {
    // Load form data from localStorage when component mounts
    if (filterValues) {
      form.setFieldsValue(filterValues);
    }
  }, [filterValues]);

  const fetchMaster = () => {
    if (masters) {
      const newObject = { label: "--Select--", value: null };
      const newArrayClass = [...masters.classes];
      newArrayClass.unshift(newObject);
      setclassArray(newArrayClass);

      const newArrayStream = [...masters.streams];
      newArrayStream.unshift(newObject);
      setstreamArray(newArrayStream);

      const newArraySubj = [...masters.subjects];
      newArraySubj.unshift(newObject);
      setsubjectArray(newArraySubj);
    }
  };
  useEffect(() => {
    fetchMaster();
  }, []);

  const onReset = () => {
    form.resetFields();
    settags([{ newcourse: { courseName: "" }, newnode: [] }]);
    setState({
      ...state,
      inputTag: null,
      selectedTag: {
        ...state.selectedTag,
        node: "",
        course: "",
        newcourse: "",
        newnode: "",
        fkCourse: null,
        fkNode: "",
      },
    });
    setSubSubEnabled(false);
    dispatch(storeSelectedTag({}));
    dispatch(StoreSubtypeEnabledInFilter(true));
    setfilterValues({ hintStatus: "HU" });
    dispatch(storeQuestionFilter({}));
    setInputTextLangauge(null);
    setRefresh(new Date().getMilliseconds());
    onCloseDrawer();
  };
  const onFinish = (values) => {
    SaveButton(values);
  };
  const SaveButton = (formValues) => {
    const allvalues = { ...formValues };
    if (formValues.myQuestions != null) {
      if (formValues.myQuestions == "createdByUser") {
        formValues.createdByUser = userInfo.user_id;
      } else {
        formValues.assignedToUser = userInfo.user_email;
      }
    }
    delete formValues.myQuestions;
    let newObj = formValues;
    newObj["languageSelected"] = inputTextLanguage ? inputTextLanguage : null;
    //Fetching filter dropdown values
    if (hintSolAns) {
      newObj["hintSolAns"] = hintSolAns;
    }
    if (newObj["hintStatus"]) {
      newObj["tags"] = newObj["hintStatus"];
      delete newObj["hintStatus"];
    }
    // if (Object.keys(questionFilter).length && questionFilter.buckets != '') {
    //     newObj['buckets'] = questionFilter?.buckets;
    //     if (bucketArr && bucketArr.length > questionFilter.buckets != null && questionFilter.buckets && questionFilter.buckets.split().length) {
    //         newObj['buckets'] = bucketArr?.map((ele) => ele.value)?.toString();
    //     } else {
    //         newObj['buckets'] = bucketArr?.map((ele) => ele.value)?.toString();
    //     }
    // } else {
    //     newObj['buckets'] = bucketArr?.map((ele) => ele.value)?.toString();
    // }
    if (
      formValues["subTypeCount"] == null ||
      formValues["subTypeCount"] == "" ||
      formValues["subTypeCount"] == "NaN" ||
      isNaN(formValues["subTypeCount"]) ||
      formValues["subTypeCount"] < 0
    ) {
      delete formValues.subTypeCount;
    }
    const ret = [];
    for (var key in newObj) {
      if (Object.prototype.hasOwnProperty.call(newObj, key)) {
        if (newObj[key] != null && newObj[key] != "") {
          ret.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(newObj[key])
          );
        }
      }
    }

    let bucketString =
      "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,46,47,49,51,52,53,54,55,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77";

    if (ret.length > 0) {
      formValues["selectedOptionsHintAnsSol"] = selectedOptionsHintAnsSol;

      dispatch(storeQuestionFilter(formValues));
      if (bucketString != "") {
        if (newObj["buckets"] != undefined && newObj["buckets"] != "") {
          //Fetching question data on the basis of applied filters
          fetchQuestion(
            BASE_URL +
              `question?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&` +
              ret.join("&"),
            newObj
          );
          onCloseDrawer();
          setfilterValues(allvalues);
        } else {
          fetchQuestion(
            BASE_URL +
              `question?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&buckets=${bucketString}&` +
              ret.join("&"),
            newObj
          );
          onCloseDrawer();
          setfilterValues(allvalues);
        }
      } else {
        fetchQuestion(
          BASE_URL +
            `question?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&` +
            ret.join("&"),
          newObj
        );
        onCloseDrawer();
        setfilterValues(allvalues);
      }
      // setUrl(ret.join('&'))
    } else {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "Please choose at least one filter",
      });
      // failureToast('Please choose at least one filter')
    }
  };

  return (
    <>
      <Form
        style={{ paddingBottom: "50px" }}
        labelWrap
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={[32, 0]}>
          <Col span={12}>
            <Form.Item
              name="streamId"
              label="Stream"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <SingleSelectComponent
                placeholder="Select Stream"
                options={streamArray}
                isVertical={true}
              ></SingleSelectComponent>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="subjectId"
              label="Subject"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <SingleSelectComponent
                placeholder="Select Subject"
                options={subjectArray}
                isVertical={true}
              ></SingleSelectComponent>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="classId"
              label="Class"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <SingleSelectComponent
                placeholder="Select Class"
                options={classArray}
                isVertical={true}
              ></SingleSelectComponent>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="hintStatus"
              label="Hint Status"
              rules={[
                {
                  required: true,
                  message: "Hint Status is required!",
                },
              ]}
            >
              <SingleSelectComponent
                placeholder="Select hint status"
                options={hintStatusOption}
                isVertical={true}
              ></SingleSelectComponent>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="questionType"
              label="Question Type"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <SingleSelectComponent
                showSearch
                options={QuestionType}
                placeholder="Select Type"
                allowClear
              ></SingleSelectComponent>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="questionId"
              label="Question ID"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input
                allowClear={true}
                min={1}
                type={"number"}
                style={{ width: "100%" }}
                suffix={
                  <Tooltip title="System generated unique ID for every question">
                    <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                }
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="questionExternalId"
              label="External Id"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input
                allowClear={true}
                suffix={
                  <Tooltip title="Enter unique system generated external ID">
                    <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                }
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="nodeShortcode"
              label="Node Short Code"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input
                allowClear={true}
                suffix={
                  <Tooltip title="Write node shortcode of this question">
                    <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          style={{
            position: "absolute",
            bottom: "0px",
            backgroundColor: "#fff",
            paddingTop: "15px",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingRight: "60px",
          }}
        >
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Apply Filter
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Clear All
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
};
QuestionFilterAntd.propTypes = {
  setfilterValues: PropTypes.func,
  sortBy: PropTypes.string,
  sortDir: PropTypes.string,
  limit: PropTypes.number,
  form: PropTypes.any,
  inputTextLanguage: PropTypes.any,
  filterValues: PropTypes.any,
  hintSolAns: PropTypes.any,
  selectedOptionsHintAnsSol: PropTypes.any,
  state: PropTypes.object,
  setState: PropTypes.func,
  settags: PropTypes.func,
  setRefresh: PropTypes.func,
  setSubSubEnabled: PropTypes.func,
  setInputTextLangauge: PropTypes.func,
  onCloseDrawer: PropTypes.func,
  fetchQuestion: PropTypes.func,
  subSubEnabled: PropTypes.any,
};
export default QuestionFilterAntd;
